import { times } from 'lodash';
import { createSpeakingTaskType } from '../../createTaskType';
import SpeakingGenericEditor from '../../sharedLogic/SpeakingGenericEditor';
import { createSpeakingMultiSelectItem } from '../../sharedLogic/speakingItemCreators';
import withProps from "@dyl/utils/withProps";
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";

export default createSpeakingTaskType({
    id: 'shop',
    label: 'Shop',
    skill: 'speaking',
    v2: true,

    editor: withProps(SpeakingGenericEditor, { includeContextAudioField: true }),
    createItemsTemplate: () => times(2, createSpeakingMultiSelectItem),

    hasEndAudio: true,
    backgroundImages: { count: 1 },

    convertToUploadFormat: speakingConvertToUploadFormat,

});